import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Paginator } from 'primereact/paginator';
import { Button } from 'primereact/button';
import { Ripple } from 'primereact/ripple';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import axios from 'axios';

const StudyListPagination = ({
  onChangePage,
  currentPage,
  perPage,
  onChangePerPage,
  onChange,
  filterValues,
  totalAllStudies
}) => {
  const { t } = useTranslation('StudyList');
  const [pageNumber, setPageNumber] = useState(1);
  const [pageInputTooltip, setPageInputTooltip] = useState('Pressione \'Enter\' para ir para a página.');
  const totalPages = Math.round(totalAllStudies / perPage);

  useEffect(() => {
    if (currentPage) {
      setPageNumber(currentPage);
    }
  }, [currentPage])


  const onChangeResultsPage = (e) => {
    onChange({
      ...filterValues,
      resultsPerPage: e.value,
      pageNumber: pageNumber
    });
  }

  const onChangePageNumber = (value) => {
    setPageInputTooltip('');
    if (value < 1 || value > totalPages) {
      setPageInputTooltip(`O valor deve estar entre 1 e ${totalPages} páginas`);
      return;
    }
    onChange({
      ...filterValues,
      resultsPerPage: perPage,
      pageNumber: value
    });
  }

  const onPageInputKeyDown = (event) => {
    if (event.key === 'Enter') {
      const page = parseInt(event.target.value);
      onChangePageNumber(page);
    }
  }

  return (
    <div className='p-menubar' style={{ justifyContent: 'center', borderRadius: '0', opacity: totalAllStudies === 0 ? '0.5' : '1' }}>
      <Button
        label=''
        icon='pi pi-angle-double-left'
        className="p-button-outlined"
        style={{ borderBottomRightRadius: 0, borderTopRightRadius: 0 }}
        disabled={pageNumber <= 1}
        onClick={e => onChangePageNumber(1)}
      />
      <Button
        label='Anterior' icon='pi pi-angle-left'
        className="p-button-outlined mr-10"
        style={{ borderRadius: 0 }}
        disabled={pageNumber <= 1}
        onClick={e => onChangePageNumber(pageNumber - 1)}
      />
      <div className='mr-10'>
        <label>Pág.</label>
        <InputText
          size={4}
          maxLength={4}
          value={pageNumber}
          onKeyDownCapture={e => onPageInputKeyDown(e)}
          onChange={e => setPageNumber(e.target.value)}
          style={{ textAlign: 'center' }}
          tooltip={pageInputTooltip}
          disabled={totalAllStudies === 0}
        />
        <label className='mr-10'> de {totalPages}</label>
      </div>
      <Button
        label='Próximo'
        icon='pi pi-angle-right'
        iconPos='right'
        className="p-button-outlined"
        style={{ borderRadius: 0 }}
        disabled={pageNumber === totalPages || totalAllStudies <= perPage || totalAllStudies === 0}
        onClick={e => onChangePageNumber(pageNumber + 1)}
      />
      <Button
        label=''
        icon='pi pi-angle-double-right'
        className="p-button-outlined mr-10"
        style={{ borderBottomLeftRadius: 0, borderTopLeftRadius: 0 }}
        disabled={pageNumber === totalPages || totalAllStudies <= perPage || totalAllStudies === 0}
        onClick={e => onChangePageNumber(totalPages)}
      />
      <Dropdown value={perPage} disabled={totalAllStudies === 0} tooltip='Resultados por página'
        onChange={e => onChangeResultsPage(e)}
        options={[
          { label: '5', value: 5 },
          { label: '25', value: 25 },
          { label: '50', value: 50 },
          { label: '100', value: 100 }
        ]}
        className='mr-10'
      /> <label>Total de registros: {totalAllStudies}</label>
    </div>
  );
};

StudyListPagination.propTypes = {
  onChangePage: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
  perPage: PropTypes.number.isRequired,
  onChangePerPage: PropTypes.func.isRequired,
};

export default StudyListPagination;
